import { ComponentRendering } from "@sitecore-jss/sitecore-jss-nextjs";

export function getAccordionSectionUids(obj: ComponentRendering): string[] {
  let uids: string[] = [];

  if (
    obj.componentName.toLocaleLowerCase().includes("accordion section") &&
    obj.uid
  ) {
    uids.push(`uid-${obj.uid}`);
  }

  if (obj.placeholders && typeof obj.placeholders === "object") {
    for (const key of Object.keys(obj.placeholders)) {
      const arr = obj.placeholders[key];
      if (Array.isArray(arr)) {
        for (const item of arr) {
          if (item && typeof item === "object" && "componentName" in item) {
            uids = uids.concat(
              getAccordionSectionUids(item as ComponentRendering),
            );
          }
        }
      }
    }
  }

  return uids;
}
